import "core-js/modules/es.array.push.js";
/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-04 16:26:09
 * @LastEditors: lihuiping lihuiping@yuouhui.com
 * @LastEditTime: 2024-08-31 15:00:33
 * @FilePath: /mzc-frontend-pc/packages/main/src/main.ts
 * @Description:主入口文件
 *
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueViewer from "v-viewer";
import Vue3TouchEvents from "vue3-touch-events";
import "@packages/share/style/var.css";
import "@packages/share/style/base.css";
//引入业务组件、项目内组件
import component from "@packages/share/components/index";
import microApp from "@micro-zoe/micro-app";
import LinkdUI from "linkd-ui";
import getNowTime from "@packages/share/utils/getNowTime";
import { warning } from "@packages/share/components/notice";
import addPath from "@packages/share/utils/addTopNavPath";
import reducePath from "@packages/share/utils/reduceTopNavPath";
import "linkd-ui/dist/style.css";
import "@wangeditor/editor/dist/css/style.css";
// 引入本项目style - 在公共share里面
import "@packages/share/style/index.css";
// 按钮权限
import reg from "@packages/share/utils/reg";
import { useBtnPermission, getBtnListByBtnType } from "@packages/share/utils/btnPermission";
import { rootRoleListDic } from "@packages/share/utils/dictionary";
import { money, currency } from "@packages/share/utils/splitThousand";
import "./permission"; // 路有权限控制
function curMonthFirstDay() {
  let year = new Date().getFullYear();
  let month = String(new Date().getMonth() * 1 + 1).padStart(2, "0");
  let day = "01";
  let time = "00:00:00";
  return year + "-" + month + "-" + day + " " + time;
}
function curMonthCurTime() {
  let year = new Date().getFullYear();
  let month = String(new Date().getMonth() * 1 + 1).padStart(2, "0");
  let day = String(new Date().getDate()).padStart(2, "0");
  let time = "23:59:59";
  return year + "-" + month + "-" + day + " " + time;
}
const app = createApp(App);
app.config.globalProperties.$money = money;
app.config.globalProperties.$currency = currency;
app.config.globalProperties.$isHaveBtn = useBtnPermission; //template 直接访问，因为有this，不能在js中访问
app.config.globalProperties.$getBtnList = getBtnListByBtnType;
app.provide("$isHaveBtn", useBtnPermission); //ts 里面访问
app.provide("$getBtnList", getBtnListByBtnType);
app.provide("$currency", currency); //ts 里面访问
app.provide("$money", money); //ts 里面访问
app.provide("$curMonthFirstDay", curMonthFirstDay); //ts 里面访问
app.provide("$curMonthCurTime", curMonthCurTime); //ts 里面访问
// 修改 JSON 的原型
const originalStringify = JSON.stringify;
JSON.stringify = function (value, replacer, space) {
  // 定义一个自定义的 replacer 函数
  function customReplacer(key, value) {
    return value === undefined ? "" : value;
  }
  // 调用原始的 JSON.stringify 方法，使用自定义的 replacer
  return originalStringify(value, customReplacer, space);
};
function loginRole() {
  let cacheCurSystem = localStorage.getItem("cur-system");
  if (cacheCurSystem) {
    let roleCode = JSON.parse(cacheCurSystem).roleCode;
    if (rootRoleListDic[roleCode]) {
      let roleName = rootRoleListDic[roleCode].name;
      return {
        [roleName]: true //给当前的登录的角色 设置 成true
      };
    }
  } else {
    return {};
  }
}
app.config.globalProperties.$loginRole = loginRole; //template 直接访问，因为有this，不能在js中访问
app.provide("$loginRole", loginRole); //ts 里面访问
app.config.globalProperties.$getNowTime = getNowTime; //template 直接访问，因为有this，不能在js中访问
app.provide("$getNowTime", getNowTime); //ts 里面访问
// 跳转控制器 start ts 里面访问
app.provide("$controller", {
  open: function (name, path, query) {
    let ts = new Date().getTime();
    let fn = () => {
      router.push({
        path: path,
        query: {
          ...query,
          ts: ts
        }
      });
    };
    addPath(path, name, fn, {
      ...query,
      ts: ts //这里不能去掉，有的列表页面没有yquery 通过 hasYQueryComponent-ts 来判断就行 更新时间戳刷新的
    });
  },

  //   close: function close(path: string) {
  //     let ts = new Date().getTime();
  //     let queryObj = {
  //       ts: ts,
  //     };
  //     let fn = () => {
  //       router.replace({
  //         path: path,
  //         query: {
  //           ts: ts,
  //         },
  //       });
  //     };
  //     reducePath(1, path, fn, queryObj);
  //   },
  returnList: function returnList(obj) {
    localStorage.setItem("btnList", JSON.stringify(getBtnListByBtnType(1))); //存储列表按钮权限
    let current3LevelMenu = ref({}); // 当前三级菜单
    let localCacheCurrent3LevelMenu = localStorage.getItem("current3LevelMenu");
    if (localCacheCurrent3LevelMenu) {
      current3LevelMenu.value = JSON.parse(localCacheCurrent3LevelMenu);
    }
    let ts = new Date().getTime();
    let queryObj = {};
    let listTs = current3LevelMenu.value.listQuery.ts;
    let levelMenuName = current3LevelMenu.value.name;
    console.log(current3LevelMenu.value);
    // 通过hasYQueryComponent-ts 来表示当前页面是否夹杂yquery 组件，如果没有搜索项，强制刷新页面
    if (listTs && !sessionStorage.getItem("hasYQueryComponent-" + listTs) && levelMenuName != "编辑赠品") {
      queryObj = {
        ...current3LevelMenu.value.listQuery,
        ts: ts,
        ...obj
      };
      //   sessionStorage.removeItem("hasYQueryComponent-" + );
    } else {
      queryObj = {
        ...current3LevelMenu.value.listQuery,
        ...obj
      };
    }
    let fn = () => {
      router.replace({
        path: current3LevelMenu.value.listUrl,
        query: queryObj
      });
    };
    reducePath(1, current3LevelMenu.value.listUrl, fn, queryObj);
  }
}); //ts 里面访问
// 跳转控制器 end
microApp.start({
  disableScopecss: true //禁用样式隔离，解决在vue3中样式失效的问题
});

import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
function regTest(regKey, regDesc, row, key) {
  if (!reg[regKey].test(row[key])) {
    row[key] = "";
    return warning(regDesc);
  }
}
app.config.globalProperties.$regTest = regTest; //template 直接访问，因为有this，不能在js中访问
app.use(ElementPlus, {
  locale: zhCn
});
app.use(VueViewer);
app.use(Vue3TouchEvents);
app.use(LinkdUI, {}).use(Vue3TouchEvents).use(router).use(component).mount("#base_goods");
// app.use(LinkdUI).use(router).mount("#base_goods")